import { combineReducers } from 'redux';
import allPage from './allPage';
import homePage from './homePage';
import newsEvent from './newsEvent';
import products from './products';
import settings from './settings';
import domain from './domain';
import instagram from './instagram';


export default combineReducers({
  homePage,
  newsEvent,
  products,
  allPage,
  settings,
  domain,
  instagram,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js